/**
 * Formatea un valor numérico como precio en guaraníes.
 * Formato: "Gs. X.XXX.XXX" (punto como separador de miles, sin decimales).
 *
 * @param {number} valor - El valor numérico a formatear
 * @returns {string} El precio formateado con prefijo "Gs."
 *
 * @example
 * formatearPrecio(1250000)  // "Gs. 1.250.000"
 * formatearPrecio(0)        // "Gs. 0"
 * formatearPrecio(-500)     // "Gs. 0"
 * formatearPrecio(999)      // "Gs. 999"
 * formatearPrecio(1000)     // "Gs. 1.000"
 */
export function formatearPrecio(valor) {
  // Tratar valores no numéricos, negativos o NaN como 0
  const numero = Math.max(0, Math.floor(Number(valor) || 0));

  // Formatear con puntos como separador de miles
  const formateado = numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `Gs. ${formateado}`;
}
